import { gql } from "@apollo/client";

export default gql`
  mutation AddPanelComment($input: PanelCommentAddArg!) {
    addPanelComment(input: $input)
  }
`;
